import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'
import { cn } from '@vgw/tailwind-merger'
import { getBrandAssetsConfig } from '@/config/assets-config'
import { useIsDesktop } from '@vgw/multibrand-fe-match-media-utils'

type AppLogoProps = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  useMobileVersion?: boolean
}

export const AppLogo = ({
  useMobileVersion = false,
  className,
  ...props
}: AppLogoProps) => {
  const { logo } = getBrandAssetsConfig()
  const { isDesktop } = useIsDesktop()

  const logoSrc = useMobileVersion
    ? isDesktop
      ? logo.desktop
      : logo.mobile
    : logo.desktop

  return (
    <img
      {...props}
      src={logoSrc}
      alt=""
      className={cn('h-full w-full object-contain', className)}
    />
  )
}
